var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HorizontalStepper',{attrs:{"steps":_vm.steps,"stepKey":_vm.stepKey,"flowName":_vm.__('kyc_title')},on:{"nav":_vm.onStepKeyChanged,"on-submit":_vm.onSubmit}}),_c('div',{staticClass:"kyc"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }